<template>
  <div class="content-wrapper">
    <el-form ref="searchForm" :model="formData.data"
      v-loading="formLoading" class="search-form" :inline="true">
      <div class="flex">
        <el-form-item label="接收人手机号" prop="receivePhone">
          <el-input
            size="small" v-model="formData.data.receivePhone"
            placeholder="手机号" clearable />
        </el-form-item>
        <el-form-item label="内容" prop="content" class="content">
          <el-input
            size="small" v-model="formData.data.content"
            placeholder="短信内容" clearable />
        </el-form-item>
        <el-form-item label="状态" prop="sendStatus">
          <el-select v-model="formData.data.sendStatus"
            clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in sendStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" class="search-btn"
            :loading="loadingSearch" @click="searchTableData">查询</el-button>
        </el-form-item>
      </div>
    </el-form>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='500'
      :loading='tableLoading'
      service
      @service-fn="handleService"
      @row-click="rowClick">
      <el-table-column prop="sendTime" label="发送时间" align="center" sortable width="180"/>
      <el-table-column prop="receivePhone" label="接收人手机号" align="center" width="140"/>
      <el-table-column prop="msgType" label="信息类型" align="center" width="140">
        <template #default="scope">
          <div>{{ scope.row.msgType==="0" ? "短信": "钉钉" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="短信内容" align="center" show-overflow-tooltip/>
      <el-table-column prop="sendStatus" label="状态" align="center"
        :formatter='formatterState' width="200"/>
    </table-pagination>
  </div>
</template>

<script>
import tables from '../../mixins/table'
import { SHORT_MESSAGE_LOG } from '../../libs/api'

export default {
  mixins: [tables],
  data() {
    return {
      formLoading: false, // 表单加载遮罩
      formInited: true, // 表单是否已完成初始化
      loadingSearch: false, // 查询按钮禁用
      tableLoading: false,
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: '',
        data: {
          // sendTime: '', // 发送时间
          receivePhone: '', // 接收人手机号
          content: '', // 内容
          sendStatus: '' // 状态
        }
      },
      dic: {
        sendState: {
          0: '未发送',
          1: '已发送',
          2: '发送失败'
        }
      },
      sendStateList: [{
        label: '未发送',
        value: 0
      }, {
        label: '已发送',
        value: 1
      }, {
        label: '发送失败',
        value: 2
      }],
      searchUrl: SHORT_MESSAGE_LOG.GET_LIST
    }
  },
  mounted() {
    // table 数据表查询
    this.searchTableData()
  },
  methods: {
    formatterState(row, column, cellValue) {
      return this.dic.sendState[cellValue]
    },
    searchTableData() {
      this.handleSearch(this.searchUrl, this.formData)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-form{
  padding-left: 25px;
  .flex{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .el-form-item{
      margin-bottom: 0px;
    }
    .content{
      width: 280px;
      /deep/.el-form-item__content{
        width: 79%;
      }
    }
  }
}
</style>
